<template>
  <div class="wrapper">
    <div class="top">
      <img src="https://static.yihu365.cn/img/card/top-icon.png" alt="">
    </div>
    <div class="card-box">
      <div class="tits">
        重要提示
      </div>
      <div class="cont">
        <div class="gt">
          <img src="https://static.yihu365.cn/img/card/gt-icon.png" alt="">
        </div>

        <div class="txts">
           <div>您正在激活卡片，<span style="color: red">请仔细核对以下信息</span>。</div>
           <div>确认无误后，点击"确认激活"按钮，</div>
           <div>激活成功后，<span style="color:#32ae92">信息将无法修改</span>，</div>
           <div>且本权益卡仅限激活人使用，</div>
           <div>享受相关权益。</div>
        </div>
        <div class="info">
            <div class="item">
              <span>姓名</span>
              <span>xsl</span>
            </div>
          <div class="item">
            <span>证件类型</span>
            <span>身份证</span>
          </div>
          <div class="item">
            <span>证件号</span>
            <span>420581199301243321</span>
          </div>
        </div>
      </div>
      <div class="btns">
         <div class="l">取&nbsp;&nbsp;&nbsp;消</div>
         <div class="r">确认激活</div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from "vue";

export default {
  name: "stepFour",
  setup(){
    let checks = ref(false);

    return {
      checks
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper{
  box-sizing: border-box;
  width: 100%;
  height:100vh;
  padding:30px 50px;
  background-image: url("https://static.yihu365.cn/img/card/bg-color.jpg");
  background-size: 100% 100%;
  position: relative;
  .top{
    img{
      width: 100%;
    }
  }
  .card-box{
    width: calc(100% - 100px);
    height:890px;
    box-sizing: border-box;
    border-radius: 20px;
    background: #FFFFFF;
    position: absolute;
    left:50px;top:300px;
    z-index: 1;
    padding:0px;
    box-shadow: 2px 2px 10px #a9a9a9;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color:#333;
    .tits{
      width: 100%;
      text-align: center;
      font-size: 34px;
      line-height: 80px;
      font-weight: 500;
      height: 80px;
      background: #b7e2d8;
      color:#30b193;
      border-radius: 20px 20px 0 0;
    }
    .cont{
      flex: 1;
      .gt{
        display: flex;
        justify-content: center;
        padding:55px 0;
        img{
          width: 90px;
        }
      }
      .txts{
        font-size: 28px;
        div{
          width: 100%;
          text-align: center;
        }
      }
      .info{
        width: 90%;
        border:2px solid #32ae92;
        border-radius: 10px;
        background: #f5fffe;
        font-size: 26px;
        box-sizing: border-box;
        margin: 40px auto 0;
        padding:2px 20px;
        .item{
           display: flex;
           justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #d2d2d2;
          height:70px;
          padding:0 10px;
        }
        .item:last-of-type{
          border:none!important;
        }
      }
    }
    .btns{
      display: flex;
      font-size: 28px;
      height:80px;
      div{
        width: 50%;
        text-align: center;
        line-height: 80px;
      }
      .l{
        background: #f1f1f1;
        border-radius: 0 0 0 20px;
      }
      .r{
        background: #32ae92;
        color:#fff;
        border-radius: 0 0 20px 0;
      }
    }
  }
}
</style>
